import { DataSubProcessor } from 'packages/candidate_export/entities/DataSubProcessorConsent';
export var getters = {
    hasKomboIntegration: function (state) { return state.exportSystems.length > 0; },
    hasKomboConsent: function (state) { var _a, _b, _c; return (_c = (state.consents.length > 0 && ((_b = (_a = state.consents) === null || _a === void 0 ? void 0 : _a.find(function (consent) { return consent.subProcessor === DataSubProcessor.KOMBO; })) === null || _b === void 0 ? void 0 : _b.isApproved))) !== null && _c !== void 0 ? _c : false; },
};
